module.exports = __webpack_public_path__ + "static/media/afCat.91dac1e3c6c979949a6fb2dc55798824.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/afCat.png
// module id = 1109
// module chunks = 1